import axiosInstance from './axiosConfig';

// Helper to build query string
const buildQuery = ({ range, range_type, year, comparison, product_ids }) => {
  const params = new URLSearchParams();
  if (range) params.append('range', range);
  if (range_type) params.append('range_type', range_type);
  if (year) params.append('year', year);
  if (comparison) params.append('comparison', comparison);
  if (product_ids && product_ids.length) params.append('product_ids', product_ids.join(','));
  return params.toString();
};

export const getTopProducts = async (params) => {
  const query = buildQuery(params);
  const response = await axiosInstance.get(`product_growth_analytics/top_products?${query}`);
  return response.data;
};

export const getLowProducts = async (params) => {
  const query = buildQuery(params);
  const response = await axiosInstance.get(`product_growth_analytics/low_products?${query}`);
  return response?.data;
};

export const getFastestGrowingProducts = async (params) => {
  const query = buildQuery(params);
  const response = await axiosInstance.get(`product_growth_analytics/fastest_growing?${query}`);
  return response?.data;
};

export const getDecliningProducts = async (params) => {
  const query = buildQuery(params);
  const response = await axiosInstance.get(`product_growth_analytics/declining_growing?${query}`);
  return response?.data;
};

export const getStreakWeekProducts = async (params) => {
  const query = buildQuery(params);
  const response = await axiosInstance.get(`product_growth_analytics/streak_week?${query}`);
  return response?.data;
};

export const getHourlyPerformance = async (params) => {
  const query = buildQuery(params);
  const response = await axiosInstance.get(`product_growth_analytics/hourly_performance?${query}`);
  return response?.data;
};

export const getFilterOption = async (params) => {
  const query = buildQuery(params);
  const response = await axiosInstance.get(`product_growth_analytics/filter_option?${query}`);
  return response?.data;
};


